<template>
  <div class="app-content content devcontent">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
        <div class="container-fluid">
          <div class="row breadcrumbs-top">
            <div class="col-md-12 content-header-left px-0">
              <h3 class="content-header-title float-left mb-0">
                Enroute-Touch Point Delay
              </h3>

              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div
          class="modal fade"
          id="imagemodal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body p-0">
                <div class="view_photo_transaction">
                  <button
                    type="button"
                    class="close imageModalClose"
                    data-dismiss="modal"
                  >
                    <x-icon
                      size="1.5x"
                      class="custom-class avatar-icon font-medium-3"
                    ></x-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <vue-element-loading :is-full-screen="true" />

        <section id="dashboard-ecommerce" class=" ">
          <div class="tab-content">
            <div
              role="tabpanel"
              class="tab-pane active"
              id="report"
              aria-labelledby="gate_tab"
              aria-expanded="true"
            >
              <div
                class="collapse-margin collapse-icon mt-0"
                id="faq-cancellation-qna"
              >
                <div class="card border rounded mb-1 mt-0">
                  <div class="card-header bg-white">
                    <span class="lead collapse-title">
                      Enroute Touch Point Delay
                    </span>
                    <span>
                      <div class="filters2 tabs_dockview">
                        <div class="filter-btn active">
                          <button>Today</button>
                        </div>
                        <div class="filter-btn"><button>Week</button></div>
                        <div class="filter-btn"><button>Month</button></div>
                      </div>
                    </span>
                  </div>
                  <div
                    id="faq-cancellation-one"
                    class=""
                    aria-labelledby="cancellationOne"
                    data-parent="#faq-cancellation-qna"
                  >
                    <div class="table-responsive mb-0">
                      <table
                        class="table dataTableListing table-hover table-striped project_name_member_text_01 custom_doctable"
                        aria-describedby="mydesc"
                      >
                        <thead class="header-primary">
                          <tr class="thfirst_dock_performance">
                            <th
                              scope="col"
                              class="text-left"
                              style="min-width: 255px"
                            >
                              Enroute Touch Point Delay
                            </th>
                            <template>
                              <th scope="col" class="text-center">Sr.No</th>
                              <th scope="col" class="text-center">
                                Vehicle No
                              </th>
                              <th scope="col" class="text-center">
                                Track Time
                              </th>
                              <th scope="col" class="text-center">Location</th>
                              <th scope="col" class="text-center">Stop Time</th>
                              <th scope="col" class="text-center">Trip No</th>
                              <th scope="col" class="text-center">Route No</th>
                              <th scope="col" class="text-center">From Ou</th>
                              <th scope="col" class="text-center">To Ou</th>
                            </template>
                          </tr>
                        </thead>
                        <tbody>
                          <vue-element-loading spinner="bar-fade-scale" />
                          <tr class="tdfirst_dock_performance">
                            <td class="text-left" style="width: 200px">
                              Enroute Delay
                            </td>
                            <template>
                              <!-- <td class="text-center">
                                                    </td> -->
                              <td class="text-center">11</td>
                              <td class="text-center">MH12WB3244</td>
                              <td class="text-center">4.40PM</td>
                              <td class="text-center">Nasik</td>
                              <td class="text-center">2.2</td>
                              <td class="text-center">22443432</td>
                              <td class="text-center">7687</td>
                              <td class="text-center">FGF</td>
                              <td class="text-center">RTY</td>
                            </template>
                          </tr>
                          <tr class="tdfirst_dock_performance">
                            <td class="text-left" style="width: 200px">
                              Touch Point Delay
                            </td>
                            <template>
                              <td class="text-center">11</td>
                              <td class="text-center">MH12WB3244</td>
                              <td class="text-center">4.40PM</td>
                              <td class="text-center">Nasik</td>
                              <td class="text-center">2.2</td>
                              <td class="text-center">22443432</td>
                              <td class="text-center">7687</td>
                              <td class="text-center">FGF</td>
                              <td class="text-center">RTY</td>
                            </template>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--  -->
          </div>
        </section>

        <!-- another div -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Pagination from "vue-pagination-2";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Treeselect from "@riophae/vue-treeselect";
import VueElementLoading from "vue-element-loading";
import {
  XCircleIcon,
  FileIcon,
  UploadIcon,
  DownloadIcon,
  EditIcon,
  XIcon,
} from "vue-feather-icons";
import CONSTANT from "../../constants.js";
import { read, utils } from "xlsx";
// import schema from "../utils/schema";
import common_methods from "../../utils/common_methods";
import searchMasterNameList from "../../utils/searchMasterNameList";

export default {
  name: "enroutedelay",
  mixins: [common_methods, searchMasterNameList],
  components: {
    Treeselect,
    DatePicker,
    VueElementLoading,
    Pagination,
    UploadIcon,
    FileIcon,
    XCircleIcon,
    DownloadIcon,
    EditIcon,
    XIcon,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.filters,
.filters2 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 8px;
}

.filters button,
.filters2 button {
  background: none;
  border: none;
  font-weight: 500;
  letter-spacing: 0.3px;
  border-radius: 2px;
  padding: 3px 5px !important;
}

/* .filters button:hover, .filters2 button:hover {
    background-color: #00bcd4;
    color: #fff
} */

/* .tabs_dockview .active {
    border-bottom: 2px solid #03A9F4;
} */
.tabs_dockview .active button {
  background: #ff9800;
  color: #fff;
}
.innerphoto_details_doc_04 {
  width: 140px;
  display: flex;
  border-bottom: 1px solid #dbdbdb;
  max-height: 140px;
  min-height: 140px;
  align-items: center;
  margin: 0px auto;
  overflow: hidden;
}
</style>
